module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.editables), function(editable) {
    return _c('div', {
      staticClass: "kp-list-group-item clearfix"
    }, [_c('label', {
      staticClass: "kp-row box-title box-title__button",
      on: {
        "click": function($event) {
          _vm.sidebarChangePanel('modifiers');
          _vm.sidebarSetElement(editable)
        }
      }
    }, [_vm._v("\n      " + _vm._s(editable.getAttribute('klickbox-edit-label')) + "\n      "), _vm._m(0, true)]), _vm._v(" "), _c('span')])
  }), 0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticClass: "btn is-circular has-icon"
  }, [_c('i', {
    staticClass: "fa fa-cog"
  })])])
}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-51bf5db0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/config/Modifiers.vue
 ** module id = 825
 ** module chunks = 1
 **/